import { z } from 'zod';

const paragraph = z.object({ id: z.string(), type: z.literal('paragraph'), markdown: z.string() });
const list = z.object({
  id: z.string(),
  type: z.literal('list'),
  ordered: z.boolean(),
  items: z.array(z.object({ id: z.string(), markdown: z.string() })),
});
const table = z.object({
  id: z.string(),
  type: z.literal('table'),
  columns: z.array(z.object({ key: z.string(), label: z.string() })),
  rows: z.array(z.object({ id: z.string(), cells: z.record(z.string()) })),
});
export const alignmentDocumentSchema = z.object({
  schemaVersion: z.literal(2),
  documentId: z.string(),
  documentVersion: z.number().int().positive(),
  title: z.string(),
  preamble: z.array(paragraph).default([]),
  sections: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      ordinal: z.number(),
      title: z.string(),
      blocks: z.array(z.discriminatedUnion('type', [paragraph, list, table])),
    })
  ),
});
export type AlignmentDocument = z.infer<typeof alignmentDocumentSchema>;
export type AlignmentReferenceTarget =
  | { kind: 'section'; sectionId: string }
  | { kind: 'block'; blockId: string }
  | { kind: 'list_item'; blockId: string; itemId: string }
  | { kind: 'table_row'; blockId: string; rowId: string }
  | { kind: 'table_cell'; blockId: string; rowId: string; columnKey: string };
export interface AlignmentReference {
  documentId: string;
  documentVersion: number;
  target: AlignmentReferenceTarget;
  quote: string;
  label: string;
}
export type AlignmentReferenceRequest = Omit<AlignmentReference, 'label'>;
